export default {
  auth: {
    register: 'Тіркеу',
    titleRegistration: 'Webitel аккаунтын құру',
    enterDomain: 'Домен енгізіңіз',
    enterUsername: 'Логин мен құпиясөзді енгізіңіз',
    enterNewUsername: 'Логин  мен сенімді құпиясөз жазыңыз',
    enterLicense: 'Лицензия кілтін енгізіңіз',
    createAccount: 'Аккаунт құру',
    domain: 'Домен',
    providersTitle: 'Немесе ...... жалғастыру',
    password: 'Құпиясөз',
    confirmPassword: 'Құпиясөзді қайталаңыз',
    key: 'Кілт',
    registerSubmit: 'Құру',
    signIn: 'Кіру',
    login: 'Кіру',
  },
};
